import React, { useEffect, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPOSStatus, drawPrice, istl } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";

export default function POSList(props) {

    const {
        signal = {},
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        route = "",
        align = "start",
        setAlign = () => { },
        view = true,
    } = props;




    const buffer = 20;
    const columns = [

        { min: true, width : 80, key: "log_date", align: "right", title: <>Log date</>, render: (e, f) => { return f?.header.log_date } },
        { min: true, width : 50, key: "status", align: "left", title: <>Status</>, render: (e, f) => { return drawPOSStatus(f.invoice) } },
        { min: true, width : 50, key: "type", align: "left", title: <>Type</>, render: (e, f) => { return "?" } },
        { min: true, width : 50, key: "cl", align: "left", title: <>CL</>, render: (e, f) => { return "?" } },
        {
            min: true, key: "name", width: 250, align: "left", title: <>Customer</>, render: (e, f) => {
                return f?.header?.customer_ship_to?.name;
            }
        },

        {
            min: true, key: "notes", width: 353, grow : true, align: "left", title: <>Notes</>, render: (e, f) => {
                return f?.header?.notes;
            }
        },


        // { min: true, key: "invoice", align: "left", title: <>Invoice</> },
        // {
        //     min: true, key: "amount", align: "left", title: <>Amount</>, render: (e, f) => {
        //         return (f?.header.amount);
        //     }
        // },
        // {
        //     min: true, key: "status", align: "left", title: <>Status</>, render: (e, f) => {
        //         return drawPOSStatus(f.invoice);
        //     }
        // },
        // {
        //     min: true, key: "name", width: 250, align: "left", title: <>Name</>, render: (e, f) => {
        //         return f?.header?.customer_ship_to?.name;

        //     }
        // },
        // {
        //     min: true, key: "date", align: "left", title: <>Date</>, render: (e, f) => {
        //         return bm_date(f?.header.date / 1000);
        //     }
        // },
        // // { min: true, key: "time", align: "left", title: <>Time</>},
        // {
        //     min: true, key: "notes", width: 353, align: "left", title: <>Notes</>, render: (e, f) => {
        //         return f?.header?.notes;
        //     }
        // },
    ];





    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.invoice === selected?.invoice) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.invoice === selected?.invoice) - _rows;
        setAlign("start");

        if (prevIndex < 2) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("point_of_sale.getNext", { "limit": 20, "invoice": data[data.length - 1]?.invoice }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        setAlign("start");
        pubCall("point_of_sale.getPrevious", { "limit": 20, "invoice": data[0]?.invoice }, (_s, _r) => {
            if (_s) {
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const fetch = () => {
        if (loading) { return }
        setLoading(true);
        let _filters = {};
        _filters.limit = 45;
        if (selected?.invoice) {
            _filters.invoice = selected.invoice;
        }

        pubCall("point_of_sale.getLast", _filters, (_s, _r) => {
            if (_s) {
                if (_r.length > 0) {
                    setAlign("end");
                }
                setData(_r);

                setSelected((_r.length > 0) ? _r[_r.length - 1] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, []);



    return (
        <div style={{ "display": (view) ? "block" : "none", "padding" : "0px 15px" }}>
            <Label style={{"textAlign" : "left"}}>&nbsp;Search Results:</Label>
            <div className="shim" />
            <Space grow size={10} style={{ "alignItems": "start" }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 600 }}>

                    <VirtualTable
                        onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                        onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                        next={next}
                        prev={prev}
                        align={align}
                        row_key={"invoice"}
                        current={selected}
                        data={data}
                        height={251}
                        columns={columns}
                        width={0}
                        loading={loading}
                        offset={430}
                        route={route}
                    />
                </div>
                <Card header={<Label style={{ "textAlign": "left" }}>POS Transaction Log</Label>} style={{ "width": "282px" }} secondary>
                    <Label>POS Transaction Log</Label>
                </Card>
            </Space>

        </div >
    )
}